import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { StandardTabs } from "../../../../../shared/components/tabs/StandardTabs"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { Occupancy } from "../components/occupancy/Occupancy"
import { Cancellations } from "../components/cancellations/Cancellations"
import { BookingDuration } from "../components/bookingDuration/BookingDuration"
import { GuestsSummary } from "../components/guestsSummary/GuestsSummary"
import { PeakHours } from "../components/peakHours/PeakHours"
import { TenantUsage } from "../components/tenantUsage/TenantUsage"

type Props = {}

export function ServiceCenterStatistics({}: Props) {
    const { l10n } = useAppLocalization()

    const tabs = [
        {
            label: l10n.getString("service-center-reports-statistics-occupancy-tab-title"),
            component: <Occupancy />,
        },
        {
            label: l10n.getString("service-center-reports-statistics-cancellations-tab-title"),
            component: <Cancellations />,
        },
        {
            label: l10n.getString("service-center-reports-statistics-booking-duration-tab-title"),
            component: <BookingDuration />,
        },
        {
            label: l10n.getString("service-center-reports-statistics-guests-tab-title"),
            component: <GuestsSummary />,
        },
        {
            label: l10n.getString("service-center-reports-statistics-customer-usage-tab-title"),
            component: <TenantUsage />,
        },
        {
            label: l10n.getString("service-center-reports-statistics-peak-hours-tab-title"),
            component: <PeakHours />,
        },
    ]

    return (
        <>
            <LocalizedStrict id="service-center-reports-statistics-page-header" attrs={{ title: true }}>
                <PageHeader page={Page.SERVICE_CENTER_STATISTICS_ROUTE} title="Statistics" />
            </LocalizedStrict>
            <StandardTabs tabs={tabs} />
        </>
    )
}
